import { ActionType } from '../infrastructure/actionTypes';
import { ISeedDivider } from '../infrastructure/interfaces';

export default (list: ISeedDivider[] = [], action: any) => {
    switch (action.type) {
        case ActionType.GET_SEED_DIVIDERS_DONE:
            const { seedDividers } = action;
            return seedDividers
        case ActionType.UPDATE_SEED_DIVIDER_DONE:
            const { updatedSeedDivider } = action;
            list = list.map(d => {
                if (d.id !== updatedSeedDivider.id) {
                    return d;
                }

                return updatedSeedDivider;
            });
            return list;
        default:
            return list;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/seedDividerList.ts